import { useEffect, useState, useRef } from "react";
import { useUserContext } from "../contexts/userContext";
import { useHasPermission } from "./useHasPermission";
import { useLoyaltyService } from "../services/loyaltyService";

export const useLoyaltyPermission = () => {
  const userContext = useUserContext();
  const { checkPermission } = useHasPermission();
  const { getLoyaltyTermsAccepted, loyaltyAcceptedResponse } = useLoyaltyService();

  const [lepTermsAccepted, setLepTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);

  const showCompanyLoyalty = userContext?.userInfo?.showCompanyLoyalty;
  const lepCanAcceptTerms = userContext?.userInfo?.lepCanAcceptTerms;
  const companyEntityId = userContext?.userInfo?.companyInfo?.companyEntityId;

  useEffect(() => {
    if (companyEntityId && !hasFetched.current && showCompanyLoyalty) {
      hasFetched.current = true;
      getLoyaltyTermsAccepted(companyEntityId).finally(() => setLoading(false)); 
    }
  }, [companyEntityId, getLoyaltyTermsAccepted]);

  useEffect(() => {
    if (loyaltyAcceptedResponse !== undefined) {
      setLepTermsAccepted(loyaltyAcceptedResponse);
    }
  }, [loyaltyAcceptedResponse]);
  const hasLoyaltyPermission = () => {
    if (checkPermission("F_LEP_PROVIDERADMIN_VIEW") && lepTermsAccepted) {
      return true;
    }

    if (showCompanyLoyalty && lepCanAcceptTerms && lepTermsAccepted) {
      return true;
    }

    if (showCompanyLoyalty && lepCanAcceptTerms && !lepTermsAccepted) {
      return true;
    }

    if (showCompanyLoyalty && !lepCanAcceptTerms && lepTermsAccepted) {
      return true;
    }

    return false;
  };

  return { hasLoyaltyPermission, loading };
};